import React from "react";

// import RegistHeader from "./RegistHeader";
import logo from "../../assets/img/logo.svg";

import styles from "./RegistComplete.module.scss";

const RegistComplete: React.FC = () => {
  return (
    <div className={styles["p-register__complete"]}>
      <div className={styles["p-register__message"]}>
        <div className={styles["p-register__text"]}>WELCOME TO</div>
        <img src={logo} className={styles["p-register__logo"]} />
      </div>
    </div>
  );
};

export default RegistComplete;
